module.exports = __webpack_public_path__ + "img/horizontal_7_7_8017.8abd7a28.png";